import React from "react";
import logo from "../img/logo.svg";
import { MdArrowForwardIos } from "react-icons/md";
import { Navbar, Button, Checkbox, Label } from "flowbite-react";
import { useSearchParams } from "react-router-dom";

const Home = () => {
  let [searchParams, setSearchParams] = useSearchParams();
  const token = searchParams.get("token");

 

  return (
    <>
      <Navbar fluid={true} rounded={true} className="shadow mb-3">
        <Navbar.Brand>
          <img src={logo} className="mr-3 ml-2 h-8 sm:h-10" alt="Ryde" />
          <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">
            Onboarding
          </span>
        </Navbar.Brand>
        <div className="flex md:order-2"></div>
      </Navbar>

      <div class="mt-5 m-auto w-full max-w-md p-4 bg-white rounded-lg sm:p-0 sm:mt-10 dark:bg-gray-800 dark:border-gray-700">
        <div class="mb-4">
          <h1 class="text-2xl mb-2 font-bold leading-none text-gray-900 dark:text-white">
            Required Documents
          </h1>
          <p className="mt-1  text-gray-600">
            Below are the required document to setup Rydesend account.
          </p>
        </div>
        <div class="flow-root">
          <ul role="list" class="divide-y divide-gray-200 dark:divide-gray-700">
            <Navbar.Link href={`/nic?token=${token}`}>
              <li class="py-3 sm:py-4 hover:shadow-md">
                <div class="flex items-center space-x-4">
                  <div class="flex-shrink-0">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_330_1230)">
                        <path
                          d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM16 18H8V16H16V18ZM16 14H8V12H16V14ZM13 9V3.5L18.5 9H13Z"
                          fill="#2E3849"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_330_1230">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div class="flex-1 min-w-0">
                    <p class="font-medium text-gray-900 truncate dark:text-white">
                      National Identity Card
                    </p>
                  </div>
                  <div class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white">
                    <MdArrowForwardIos />
                  </div>
                </div>
              </li>
            </Navbar.Link>
            <Navbar.Link href={`/driving-license?token=${token}`}>
              <li class="py-3 sm:py-4">
                <div class="flex items-center space-x-4">
                  <div class="flex-shrink-0">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_330_1230)">
                        <path
                          d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM16 18H8V16H16V18ZM16 14H8V12H16V14ZM13 9V3.5L18.5 9H13Z"
                          fill="#2E3849"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_330_1230">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div class="flex-1 min-w-0">
                    <p class="font-medium text-gray-900 truncate dark:text-white">
                      Driving License
                    </p>
                  </div>
                  <div class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white">
                    <MdArrowForwardIos />
                  </div>
                </div>
              </li>
            </Navbar.Link>
            <Navbar.Link href={`/profile-picture?token=${token}`}>
              <li class="py-3 sm:py-4">
                <div class="flex items-center space-x-4">
                  <div class="flex-shrink-0">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_330_1230)">
                        <path
                          d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM16 18H8V16H16V18ZM16 14H8V12H16V14ZM13 9V3.5L18.5 9H13Z"
                          fill="#2E3849"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_330_1230">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div class="flex-1 min-w-0">
                    <p class="font-medium text-gray-900 truncate dark:text-white">
                      Profile Picture
                    </p>
                  </div>
                  <div class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white">
                    <MdArrowForwardIos />
                  </div>
                </div>
              </li>
            </Navbar.Link>
            <Navbar.Link href={`/personal-details?token=${token}`}>
              <li class="py-3 sm:py-4">
                <div class="flex items-center space-x-4">
                  <div class="flex-shrink-0">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_330_1230)">
                        <path
                          d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM16 18H8V16H16V18ZM16 14H8V12H16V14ZM13 9V3.5L18.5 9H13Z"
                          fill="#2E3849"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_330_1230">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div class="flex-1 min-w-0">
                    <p class="font-medium text-gray-900 truncate dark:text-white">
                      Personal Details
                    </p>
                  </div>
                  <div class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white">
                    <MdArrowForwardIos />
                  </div>
                </div>
              </li>
            </Navbar.Link>
            <Navbar.Link href={`/emergency-contact?token=${token}`}>
              <li class="py-3 sm:py-4">
                <div class="flex items-center space-x-4">
                  <div class="flex-shrink-0">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_330_1230)">
                        <path
                          d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM16 18H8V16H16V18ZM16 14H8V12H16V14ZM13 9V3.5L18.5 9H13Z"
                          fill="#2E3849"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_330_1230">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div class="flex-1 min-w-0">
                    <p class="font-medium text-gray-900 truncate dark:text-white">
                      Emergency Contact
                    </p>
                  </div>
                  <div class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white">
                    <MdArrowForwardIos />
                  </div>
                </div>
              </li>
            </Navbar.Link>
            <Navbar.Link href={`/vehicle-details?token=${token}`}>
              <li class="py-3 sm:py-4">
                <div class="flex items-center space-x-4">
                  <div class="flex-shrink-0">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_330_1230)">
                        <path
                          d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM16 18H8V16H16V18ZM16 14H8V12H16V14ZM13 9V3.5L18.5 9H13Z"
                          fill="#2E3849"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_330_1230">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div class="flex-1 min-w-0">
                    <p class="font-medium text-gray-900 truncate dark:text-white">
                      Vehicle Details
                    </p>
                  </div>
                  <div class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white">
                    <MdArrowForwardIos />
                  </div>
                </div>
              </li>
            </Navbar.Link>
            <Navbar.Link href={`/vehicle-log?token=${token}`}>
              <li class="py-3 sm:py-4">
                <div class="flex items-center space-x-4">
                  <div class="flex-shrink-0">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_330_1230)">
                        <path
                          d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM16 18H8V16H16V18ZM16 14H8V12H16V14ZM13 9V3.5L18.5 9H13Z"
                          fill="#2E3849"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_330_1230">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div class="flex-1 min-w-0">
                    <p class="font-medium text-gray-900 truncate dark:text-white">
                      Vehicle Log
                    </p>
                  </div>
                  <div class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white">
                    <MdArrowForwardIos />
                  </div>
                </div>
              </li>
            </Navbar.Link>
            <Navbar.Link href={`/motorcyce-insurance?token=${token}`}>
              <li class="py-3 sm:py-4">
                <div class="flex items-center space-x-4">
                  <div class="flex-shrink-0">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_330_1230)">
                        <path
                          d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM16 18H8V16H16V18ZM16 14H8V12H16V14ZM13 9V3.5L18.5 9H13Z"
                          fill="#2E3849"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_330_1230">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div class="flex-1 min-w-0">
                    <p class="font-medium text-gray-900 truncate dark:text-white">
                      Motorcycle Insurance
                    </p>
                  </div>
                  <div class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white">
                    <MdArrowForwardIos />
                  </div>
                </div>
              </li>
            </Navbar.Link>
          </ul>
        </div>
      </div>



      
      <div className="home-s shadow-md">
        <div className="m-auto mt-10 w-full max-w-md p-6" href="#">
          <h5 className="text-xl mb-5 font-bold tracking-tight text-gray-900 dark:text-white">
            Review and Submit
          </h5>
          <div className="flex gap-2 mb-5">
            <Checkbox id="remember" />
            <Label htmlFor="remember" className="text-gray-500">
              I declare that the information provided is true and correct. Any
              dishonesty may render for refusal of this application or immediate
              termination of partnership.
            </Label>
          </div>
          <div className="flex gap-2">
            <Checkbox id="remember" />
            <Label htmlFor="remember" className="text-gray-500">
              By checking this, you have agree to our <a href="https://www.rydesharing.com/privacy-policy/" target="_blank" rel="noreferrer"><u>Privacy Policy</u></a>, Terms of
              Service, Code of Conduct, and Collecting and Sharing Personal
              Data.
            </Label>
          </div>
          <Button className="w-full mt-5" pill={true} disabled={true}>
            Submit For Review
          </Button>
        </div>
      </div>
    </>
  );
};

export default Home;
